import api from "./api";

const safeGet = async (path) => {
  try {
    const res = await api.get(path);
    return res.data?.data;
  } catch (error) {
    return null;
  }
};

export const getSettings = () => safeGet("/settings");
export const getStats = async () => (await safeGet("/stats")) || [];
export const getTestimonials = async () => (await safeGet("/testimonials")) || [];
export const getDoctors = async () => (await safeGet("/doctors")) || [];
